import { REALTIME_DOMAINS } from "./constants";

/**
 * Map server channel class names to dispatch domains.
 * Add entries when you add Action Cable channels on the server.
 */
const CHANNEL_TO_DOMAIN = {
  AlertChannel: REALTIME_DOMAINS.ALERT,
  ChatChannel: REALTIME_DOMAINS.CHAT,
  PresenceChannel: REALTIME_DOMAINS.PRESENCE,
};

function channelToDomain(channel) {
  if (CHANNEL_TO_DOMAIN[channel]) return CHANNEL_TO_DOMAIN[channel];
  if (!channel || typeof channel !== "string") return "unknown";
  return channel.replace(/Channel$/, "").toLowerCase();
}

function domainForType(type, channel) {
  const normalized = String(type || "");
  if (
    normalized.indexOf("message.") === 0 ||
    normalized.indexOf("conversation.") === 0
  ) {
    return REALTIME_DOMAINS.CHAT;
  }
  if (normalized.indexOf("presence.") === 0) {
    return REALTIME_DOMAINS.PRESENCE;
  }
  return channelToDomain(channel);
}

/**
 * Turn an Action Cable broadcast envelope into a stable app event.
 * @returns {{ domain: string, type: string, payload: unknown, meta: object } | null}
 */
export function normalizeCableBroadcast(identifierString, messageBody) {
  let channel;
  try {
    const parsed = JSON.parse(identifierString);
    channel = parsed.channel;
  } catch {
    return null;
  }

  let type = "message";
  let payload = messageBody;

  if (messageBody && typeof messageBody === "object") {
    if (typeof messageBody.type === "string") type = messageBody.type;
    if ("payload" in messageBody) payload = messageBody.payload;
  }

  const domain = domainForType(type, channel);

  return {
    domain,
    type,
    payload,
    meta: {
      channel,
      identifier: identifierString,
      rawMessage: messageBody,
    },
  };
}
